<template>
    <div class="radio-input-custom">
        <el-radio-group
            v-model="radioValue"
            :disabled="disabled"
            @change="handleRadioChange"
        >
            <el-radio
                v-for="(item,index) in options"
                :key="index"
                :label="item.value"
            >
                {{ item.label }}
            </el-radio>
        </el-radio-group>
        <el-input
            v-if="radioValue === showInputValue"
            v-model="inputValue"
            :disabled="disabled"
            :maxlength="maxlength"
        />
    </div>
</template>

<style lang="sass">
@imp "./index.less"
</style>

<script>
export default {
  name:"RadioinputCustom",

  props:{
    value:{
      type:Object,
      default:() => ({})
    },

    options:{
      type:Array,
      default: () => []
    },

    showInputValue:{
      type:[Number, String],
      default: null
    },

    maxlength:{
      type:Number,
      default: 20
    },

    disabled:{
      type:Boolean,
      default:false
    }
  },

  data() {
    return {
      radioValue: null,
      inputValue:""
    };
  },

  watch:{
    value(val, oldVal) {
      if (!val) return;
      
      if (val.radio === oldVal.radio && val.input === oldVal.input) return;

      const { radio,input } = val;
      
      if (input && !this.options.find(item => item.value === radio) || input === this.showInputValue) {
        this.radioValue = this.showInputValue;
        this.inputValue = input;
      }
      else {
        this.radioValue = radio;
        this.inputValue = input;
      }
    },

    inputValue(val) {
      const res = {
        input:val,
        radio:this.radioValue
      };

      this.$emit("input",res);
      this.$emit("change",res);      
    }
  },

  methods:{
    handleRadioChange(val) {
      this.inputValue = "";

      const res = {
        input:this.inputValue,
        radio:val
      };
      
      this.$emit("input",res);
      this.$emit("change",res);      
    },

    reset() {
      this.radioValue = null;
      this.inputValue = "";
    }
  }
};
</script>